import React, { Component } from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';
import { LinkContainer } from 'react-router-bootstrap';
// import wrp from '../../../hoc/Wrp/Wrp';


class HeaderTabs extends Component {
    defaultOnclickHandler = () =>{

    }
    render () {
        
        const headerTabsList = this.props.headerTabsList.map((item, i) => {
            const href = (item.href) ? item.href: "#";
            const eventsHandler = {
              onClick: (item.clickHandler) ? item.clickHandler : this.defaultOnclickHandler.bind(),
             }
             const style = (item.disabled) ? {pointerEvents:'none',opacity:'0.7'}:{}
             let liClassName = ['nav-item'];
             if(item.liClass){
               liClassName.push(item.liClass);
             }
             return(
                <li className={(liClassName).join(' ')} key={i}>
                <LinkContainer to={href} {...eventsHandler} style={style}>
                  <a   data-toggle="tab11"  role="tab" 
                  {...item.attributes} key={i} 
                    style={style} >
                        {item.name}
                  </a>
                </LinkContainer>
                </li>
             )
  
             
        });
        const UL = this.props.UL ? this.props.UL:'ul';
        return (
            
                <UL {...this.props.attributes} >
                    {headerTabsList}									 
                </UL>
            
            
            
            
        )
    }
}

export default HeaderTabs;


